<template>
  <div class="enterprise-list-page enterprise-list-page--service-entry service-entry-page">

    <!-- Header Card -->
        <PageHeader icon="fas fa-hand-holding-medical">
      <template #title>
        Tambah Layanan Medis
      </template>
      <template #subtitle>
        Definisikan tarif baru, jenis tindakan, dan deskripsi kategori layanan
      </template>
    </PageHeader>

    <!-- Main Row -->
    <div class="row">

      <!-- Form -->
      <div class="col-md-12">
        <!-- <Card :title="'Tambah Biaya Layanan'"> -->
          <!-- <template v-slot:body> -->
          <template>
            <Form
              :form="form"
              :route="'payment-categories'"
            />
          </template>
        <!-- </Card> -->
      </div>

    </div>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import Form from '@/component/masters/payment-categories/Form.vue'
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  data() {
    return {
      form: {
        name: '',
        price: '',
        description: '',
        payment_category_type_id: '',
        doctor_commission: '',
        hospital_income: '',
        employee_commission:"",
        isBundle : false,
        isMedicine : false,
        service_unit_codes: [],
      },
    }
  },

  components: {
    Card,
    Form
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Daftar Layanan", route: "" },
      { title: "Layanan", route: "/payment-categories/list" },
      { title: "Tambah" },
    ])
  },

}

</script>
